import { Component, inject, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { ReportsState } from "./store";
import { AuthService, RestoreSession } from 'core';
import { NavigationCancellationCode, Router, RouterOutlet } from '@angular/router';
import { environment } from '../environments/environment';
import { FirebaseService } from 'projects/menus/src/app/services/firebase.service';
import { catchError, firstValueFrom, from, of, switchMap, take } from 'rxjs';
import { Auth, idToken, signOut } from '@angular/fire/auth';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  title = 'reports';
  private fbServ = inject(FirebaseService);
  private authServ = inject(AuthService);
  private auth = inject(Auth);
  private router = inject(Router);

  constructor(private store: Store<ReportsState>) { }

  async authReset() {
    const resetId = environment.resetId;
    const savedId = localStorage.getItem('resetId');
    if (savedId && resetId !== savedId) {
      console.log('Clearing FB Auth!');
      await this.fbServ.logout();
      if (this.authServ.token)
        this.authServ.internalSignInWithFirebase(this.authServ.token);
    }
    localStorage.setItem('resetId', environment.resetId);
    console.log('Skipped FB Auth Clear...');
    return Promise.resolve();
  }

  async checkForInternalToken(firebaseToken: string) {
    const internalToken = this.authServ.token;

    if (internalToken) {
      return Promise.resolve(internalToken);
    } else {
      return firstValueFrom(
        this.authServ.internalSignInWithFirebase(firebaseToken)
      );
    }
  }

  logout() {
    signOut(this.auth);
  }

  ngOnInit() {
    console.log(NavigationCancellationCode);
    
    
    // Initial application check for stored authentication
    this.store.dispatch(new RestoreSession());
    idToken(this.auth).pipe(
      take(1),
      switchMap(firebaseToken => {
        if (firebaseToken) {
          console.log('Has FB TOKEN');
          
          return from(this.authReset()
            .then(() => this.checkForInternalToken(firebaseToken))
            .then(result => {
              if (typeof result === 'object')
                return result.ls_jwt_token;
              return result;
            })
          );
        }
        return of(null);
      }),
      catchError(err => {
        console.log('Hit ERROR');
        this.authServ.signOut();
        this.fbServ.logout();
        return of({ error: true });
      })
    ).subscribe(result => {
      if (typeof result === 'string') {
        this.store.dispatch(new RestoreSession());
      } else {
        console.log('Triggering CLEAR AUTH');
        
      //   // this.authServ.signOut();
      //   Promise.all([
      //     this.fbServ.logout(),
      //     // this.auth.signOut()
      //   ]).then(() => {
      //     this.store.dispatch(new RestoreSession());
      //     this.router.navigate(['/login'])
      //   });
      }
    });
  }
}
